import _ from "lodash";
import { BILLING_ANNUAL_BILLING_BASED_ON_200KL, fetchProviderByConnectionSizeCategories, WaterProvider } from "../misc";
import { queryKpisOpenData } from "../misc/kpiOpenApi";
import { CategoryChart, KpiReport } from "../processors";

export const getKpisForProviders = async (
    kpis?: string[][],
    providers?: WaterProvider[],
    queryMedianProviders: boolean = false
): Promise<KpiReport[]> => {
    const allow =
        !kpis || !kpis.filter(d => d != null).length || !providers || !providers.filter(d => d != null).length
            ? false
            : true;
    if (!allow) return null;

    let providersMeta = providers;

    const conSizeCategories = _.uniq(providers?.map(d => d.connectionSizeCategory)?.filter(d => d != null));

    if (queryMedianProviders && conSizeCategories?.length > 0) {
        // const conSizeQuery = `(${_.join(
        //     conSizeCategories.map(conCat => `"${conCat}"`),
        //     "OR"
        // )})`;
        // const solrQuery = _.join(
        //     [
        //         "q=*:*",
        //         "rows=1000",
        //         `fq=pure_strings_connection_size_ct:${conSizeQuery}`,
        //         // "fl=pure_strings_sname,pure_strings_admin_id,its_tid,pure_strings_connection_size_ct,pure_strings_residential_tariff_struct,fts_connection_size"
        //         `fl=${PROVIDER_FIELDS}`
        //     ],
        //     QUERY_URL_AND
        // );

        // console.log("getKpisForProviders");
        // const _providers = await queryWaterProviderWithDocs(solrQuery);

        const _providers = await fetchProviderByConnectionSizeCategories(conSizeCategories);
        //, {
        //cache: "no-cache"
        //});

        providersMeta = _.uniqBy([...providers, ..._providers], d => d.tid);
    }

    return queryKpisOpenData(
        {
            providerNames: providersMeta?.map(d => d.kapiName),
            kpis
        },
        providersMeta,
        {
            cache: "force-cache"
        }
    );
};

export const getKpisForProvidersWithCategoryChart = async (
    kpis: string[][],
    providers: WaterProvider[],
    queryMedianProviders: boolean,
    categoryChart?: CategoryChart
): Promise<KpiReport[]> => {
    const results = await getKpisForProviders(kpis, providers, queryMedianProviders ?? false);
    const cleanResults = results?.filter(d =>
        categoryChart?.category?.adminId?.indexOf(BILLING_ANNUAL_BILLING_BASED_ON_200KL) > -1 &&
        (d?.provider?.residentialTariffStruct === "fixed" ||
            d?.provider?.residentialTariffStruct === "consumptionCharge" ||
            d?.provider?.residentialTariffStruct === "fixedEntitlementAndExcessConsumptionCharge" ||
            d?.provider?.residentialTariffStruct === "noChargeToResidents")
            ? false
            : true
    );

    // if (categoryChart?.category?.adminId?.indexOf(BILLING_ANNUAL_BILLING_BASED_ON_200KL) > -1) {
    //     console.log(results, cleanResults, providers);
    // }
    return cleanResults;
};
